export const DASHBOARD = 'dashboard'
export const SUMMARY = 'summary'
export const COST_ALLOCATION_TAGS = 'cost-allocation-tags'
export const CLOUD_FRONT = 'cloud-front'
export const DATA_TRANSFER = 'data-transfer'
export const ALL_CONSOLIDATED = 'all-consolidated'
export const COST_PIVOT = 'cost-pivot'
export const DYNAMIC_SEARCH = 'dynamic-search'
export const INVOICE = 'invoices'
export const REGULLAR_BILLING = 'regularbilling'
export const CREDIT_CARD_USER = 'credit-card-user'
export const OPEN_API = 'open-api'
export const PROMOTION_CREDIT = 'promotion-credit'

export const BASE_SERVICES = {
    default: []
}

/** navMenuItems */
export const PROVIDED_SERVICES = {
    [DASHBOARD]: {
        order: 1,
        title: 'Dashboard',
        route: 'dashboard',
        icon: 'LayoutIcon'
    },
    [SUMMARY]: {
        order: 2,
        title: 'Summary',
        route: 'summary',
        icon: 'LayoutIcon'
    },
    [COST_ALLOCATION_TAGS]: {
        order: 3,
        title: 'Cost by Tag',
        route: 'tags',
        icon: 'TagIcon'
    },
    [CLOUD_FRONT]: {
        order: 4,
        title: 'CloudFront',
        route: 'cloudfront',
        icon: 'GlobeIcon'
    },
    [DATA_TRANSFER]: {
        order: 5,
        title: 'Data Transfer',
        route: 'data-transfers',
        icon: 'MapIcon'
    },
    [ALL_CONSOLIDATED]: {
        order: 6,
        title: 'All Consolidated',
        route: 'consolidated',
        icon: 'PieChartIcon'
    },
    [COST_PIVOT]: {
        order: 7,
        title: 'Cost Pivot',
        route: 'pivot',
        icon: 'TabletIcon'
    },
    [DYNAMIC_SEARCH]: {
        order: 8,
        title: 'Dynamic Search',
        route: 'dynamic-search',
        icon: 'SearchIcon'
    },
    [INVOICE]: {
        order: 9,
        title: 'Invoices',
        route: 'invoices',
        icon: 'FileTextIcon'
    },
    [CREDIT_CARD_USER]: {
        order: 10,
        title: 'Paying by card',
        route: 'payment-card',
        icon: 'CreditCardIcon'
    },
    [REGULLAR_BILLING]: {
        order: 11,
        title: 'Register Card',
        route: 'register-card',
        icon: 'SettingsIcon'
    },
    [OPEN_API]: {
        order: 12,
        title: 'Open API',
        route: 'open-api',
        icon: 'CodeIcon'
    }
}
